export const PRODUCTION_DEFAULT_DURATION = 60
export const CHARTER_DEFAULT_DELAY = 21
